var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"week-days"},_vm._l((_vm.weekDays),function(weekDay,index){return _c('div',{key:index,staticClass:"weekday no-translate",style:(_vm.styles)},[_vm._v("\n    "+_vm._s(weekDay.substring(0,1))+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }